<template>
    <div class="">
        <NavMenu/>
        <header class="masthead" style="bottom: -60px;">
            <div class="container px-md-5 px-4">
                <div class="">
                <div class="row">
                    <div class="col-md-6 px-lg-5 px-3">
                    <div class="header-content">
                        <h1 class="">Helmet Predictor</h1>
                        <p class="">Upload a photo of a human head and I will predict whether they're wearing a construction helmet or not.</p>
                        <div class="d-sm-block d-none">
                        <div class="mt-5 d-flex">
                            <!-- <a class="btn btn-light btn-lg mr-3 text-dark" href="/signup">Get Started</a> -->
                            <button class="btn btn-outline-light btn-lg"> See our Demo</button>
                        </div>

                        </div>
                    </div>
                    </div>
                    <div class="col-md-6 d-sm-block d-none" style="margin-top: -70px;">
                    <div class="">
                        <img src="@/assets/api.png" alt="" style="width: 650px;">
                    </div>
                    </div>
                </div>
                </div>
            </div>
        </header>
    
        <div class="container px-md-5 px-4" style="background: #fff;">
            <div class="row">
                    <div class="col-md-12">
                        <div class="card border-0 rounded-0">
                        <div class="card-body pb-2"> 
                            <div class="row my-2">
                                <div class="col-lg-6 order-1">
                                    <div class="file-upload-form">
                                        <div class="col-md-6">
                                            <h6 class="font-weight-bold">Upload a Photo</h6>
                                        </div>
                                        <div class="col-md-12">
                                            <div class="row">
                                                <div class="col-lg-6">
                                                    <div class="form-group mb-3 align-items-center justify-content-center">
                                                        <input type="file" id="file" accept="image/*" ref="file" class="mr-3" @change="previewImage">
                                                    </div>
                                                </div>
                                                <div class="col-lg-6">
                                                    <button class="btn btn-moneypool-sm" v-on:click="submitFile()">Click to Predict</button>
                                                </div>
                                            </div>
                                        </div>
                                    
                                        <div class="image-preview" v-if="preview.length > 0">
                                            <img class="preview" :src="preview">
                                        </div>
                                    </div>
                                </div>
                                <div class="col-lg-6 order-2">
                                    <div v-if="loading">
                                        
                                        Consulting the oracle...
                                        <b-spinner small label="Consulting the oracle..." variant="primary"></b-spinner>
                                
                                    </div>
                                    <div v-if="!loading">
                                        <div class="col-md-3">
                                            <h6 class="font-weight-bold">Output</h6>
                                        </div>

                                        <div class="col-md-12 table-responsive">
                                            <table class="table table-bordered">
                                                <thead>
                                                    <tr>
                                                        <th scope="col">S/N</th>
                                                        <th scope="col" class="font-weight-normal">Prediction</th>
                                                        <th scope="col" class="font-weight-normal">Accuracy</th>
                                                        <th scope="col" class="font-weight-normal">Coordinates</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr v-for="(result, index) in output" :key="index">
                                                    <th scope="row">{{ index + 1 }}</th>
                                                        <td >{{result.prediction}}</td>
                                                        <td >{{parseFloat(result.prediction_confidence).toFixed(1)+"%"}}</td>
                                                        <td >X1: {{result.x1}}, X2: {{result.x2}}, Y1: {{result.y1}}, X1: {{result.y2}}</td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        </div>
                    </div>
            </div>
        </div>
        <FooterArea/>
    </div>
</template>
<script>
import { mapState } from 'vuex';
import NavMenu from "../components/NavMenu";
import FooterArea from "../components/FooterArea";


export default {
    components: {
        NavMenu,
        FooterArea
    },
    data() {
        return {
        file: '',
        output: '',
        preview: '',
        fileref: '',
        loading: false
        };
    },
    methods: {
        submitFile() {
            
            let formData = new FormData();
            formData.append('image', this.file);

            let currentObj = this;
            currentObj.loading = true;
            axios.post('https://helmetai.devmoment.com/detect', formData, 
                {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
                })
            .then(function (response) {
                currentObj.output = response.data.results;
                currentObj.loading = false;
            })
            .catch(function (error) {
                currentObj.output = error.message;
                currentObj.loading = false;
            });
        },
        previewImage: function(event) {
            // Reference to the DOM input element
            var input = event.target;

            this.file = this.$refs.file.files[0];
            this.fileref = this.$refs.file
            // Ensure that you have a file before attempting to read it
            if (input.files && input.files[0]) {
                // create a new FileReader to read this image and convert to base64 format
                var reader = new FileReader();
                // Define a callback function to run, when FileReader finishes its job
                reader.onload = (e) => {
                    // Note: arrow function used here, so that "this.file" refers to the file of Vue component
                    // Read image as base64 and set to file
                    this.preview = e.target.result;
                }
                // Start the reader job - read file as a data url (base64 format)
                reader.readAsDataURL(input.files[0]);
            }
        }

    },
    computed: {
        ...mapState([
            'loading_state'
        ])
    }
}
</script>

<style scoped>
  @import '../assets/css/one-page-wonder.css';

header {
    background: transparent linear-gradient(270deg, #04485f  5%, #ffd23f69 50%, #ffffff 100%) 0% 0% no-repeat padding-box;
    /* background-image: url('../assets/api.png');
    background-repeat: no-repeat; */
    /* background-color: #163a54; */
    /* color: #ffffff; */
}  
.file-upload-form, .image-preview {
    /* font-family: "Helvetica Neue",Helvetica,Arial,sans-serif; */
    padding: 20px;
}
img.preview {
    width: 300px;
    background-color: white;
    border: 1px solid #DDD;
    padding: 5px;
}
</style>